import { useEffect } from 'react';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/UserContext';
import { useSidebarFiltros } from '../../contexts/SidebarFiltrosContext';
import api from '../../services/api';
import Header from '../Header';
import { IconListDemand, IconProfessional, IconOperator, IconBell, IconProfile, IconPlanos } from '../icons';
import Sidebar from '../Sidebar';
import MobileMenu from '../MobileMenu';
import { Container, Main } from './styles';
import toast, { Toaster } from 'react-hot-toast';
import { clarity } from 'react-microsoft-clarity';

interface ItemSubmenu {
    id: any;
    name: string;
    to: string;
    icon: any;
}

export interface PropsSidebar {
    id: any;
    name: string;
    to: string;
    notification?: number;
    icon: any;
    subMenu: ItemSubmenu[];
}

export default function Layout(props:any) {
    const { user, pageName, pageType } = useAuth();
    const { pathname } = useLocation();
    const { isSidebarFiltrosOpen, setSidebarFiltrosOpen } = useSidebarFiltros();
    const isPlanosRoute = pathname === '/planos' || pathname.startsWith('/planos/');


    try {
        clarity.setTag('id_usuario', user.id)
        clarity.setTag('nome', user.nome)
        clarity.setTag('email', user.email)
        clarity.setTag('tipo', user.profile)
    }
    catch (error) {}

    const [ counters, setcounters ] = useState<any>();

    const handleSidebarExpand = () => {
        // Quando a sidebar principal for expandida, fecha a sidebar de filtros
        if (isSidebarFiltrosOpen) {
            setSidebarFiltrosOpen(false);
        }
    };

    const handleSidebarToggle = () => {
        // Quando a sidebar principal for clicada (qualquer ação), fecha a sidebar de filtros
        if (isSidebarFiltrosOpen) {
            setSidebarFiltrosOpen(false);
        }
    };

    useEffect(() => {
        async function getCounters() {
            try {
                let queryString = user?.profile === 'Solicitante' ? `?&tipo_usuario=${user.profile}&id_escritorio_solicitante=${user.id_escritorio_solicitante}` : '';
                const response = await api.get(`contadores${queryString}`);
                setcounters(response.data.result);
                
                if (response.data.status !== 'success') {
                    throw new Error('Não foi possível encontrar os contadores')
                }
            } catch (error: any) {
                toast.error(error.message, {
                    duration: 3000,
                    className: 'toasted',
                    style: {
                        padding: '16px',
                        color: 'var(--c1a2858)',
                    },
                    iconTheme: {
                        primary: 'var(--cf24343)',
                        secondary: 'var(--cfffaee)',
                    },
                });
            }
        }

        getCounters();

        const handleRefreshCounters = () => {
            getCounters();
        };

        window.addEventListener('refreshCounters', handleRefreshCounters);

        return () => {
            window.removeEventListener('refreshCounters', handleRefreshCounters);
        };
    }, [pageName, user])

    const adminData = [
        {
            id: 3,
            name: 'Demandas',
            to: '/demandas',
            notification: counters?.qtd_demandas ? counters.qtd_demandas : 0,
            icon: <IconListDemand color='#54666F'/>,
            subMenu: []
        },
        {
            id: 4,
            name: 'Profissionais',
            to: '/profissionais',
            notification: counters?.qtd_profissionais ? counters.qtd_profissionais : 0,
            icon: <IconProfessional color='#54666F'/>,
            subMenu: []
        },
        {
            id: 5,
            icon: <IconOperator color='#54666F'/>,
            name: 'Operadores',
            to: '/operadores',
            notification: counters?.qtd_operadores ? counters.qtd_operadores : 0,
            subMenu: []
        },
        {
            id: 7,
            icon: <IconBell color='#54666F'/>,
            name: 'Notificações',
            to: '/notificacoes',
            notification: counters?.qtd_notificacoes ? counters.qtd_notificacoes : 0,
            subMenu: []
        },
        {
            id: 8,
            icon: <IconProfile color='#54666F'/>,
            name: 'Solicitantes',
            to: '/solicitantes',
            notification: counters?.qtd_solicitantes ? counters.qtd_solicitantes : 0,
            subMenu: []
        },
        {
            id: 9,
            icon: <IconPlanos color="#54666F" />,
            name: 'Planos',
            to: '/planos',
            notification: counters?.qtd_planos ?? 0,
            subMenu: []
        },
    ]
    const operatorData = [
        {
            id: 3,
            name: 'Demandas',
            to: '/demandas',
            notification: counters?.qtd_demandas ? counters.qtd_demandas : 0,
            icon: <IconListDemand color='#54666F'/>,
            subMenu: []
        },
        {
            id: 4,
            name: 'Profissionais',
            to: '/profissionais',
            notification: counters?.qtd_profissionais ? counters.qtd_profissionais : 0,
            icon: <IconProfessional color='#54666F'/>,
            subMenu: []
        },
        {
            id: 7,
            name: 'Notificações',
            to: '/notificacoes',
            notification: counters?.qtd_notificacoes ? counters.qtd_notificacoes : 0,
            icon: <IconBell color='#54666F'/>,
            subMenu: []
        },
        {
            id: 8,
            icon: <IconProfile color='#54666F'/>,
            name: 'Solicitantes',
            to: '/solicitantes',
            notification: counters?.qtd_solicitantes ? counters.qtd_solicitantes : 0,
            subMenu: []
        },
        {
            id: 9,
            icon: <IconPlanos color="#54666F" />,
            name: 'Planos',
            to: '/planos',
            notification: counters?.qtd_planos ?? 0,
            subMenu: []
        },
    ]
    const data = [
        {
            id: 3,
            name: 'Demandas',
            to: '/demandas',
            notification: counters?.qtd_demandas ? counters.qtd_demandas : 0,
            icon: <IconListDemand color='#54666F'/>,
            subMenu: []
        },
    ]
    const dataSolicitante = [
        {
            id: 3,
            name: 'Demandas',
            to: '/demandas',
            notification: counters?.qtd_demandas ? counters.qtd_demandas : 0,
            icon: <IconListDemand color='#54666F'/>,
            subMenu: []
        },
    ]

    return (
        <Container>
            <div className='hidden sm:flow-root'>
                <Sidebar
                    list={
                          user?.profile === 'admin'    ? adminData
                        : user?.profile === 'operador' ? operatorData
                        : user?.profile === 'comum'    ? data
                        : user?.profile === 'Solicitante' && dataSolicitante
                    }
                    forceCollapsed={isSidebarFiltrosOpen}
                    onSidebarExpand={handleSidebarExpand}
                    onSidebarToggle={handleSidebarToggle}
                />
            </div>
            <div className='block sm:hidden' style={{ position: 'fixed', top: 18, left: 0, zIndex: 1001, pointerEvents: 'none' }}>
                <MobileMenu counters={counters} />
            </div>



            <Main sidebarFiltrosOpen={isSidebarFiltrosOpen}>
                {pageType !== 'vazio' && (
                    <Header
                        title={isPlanosRoute ? 'Planos' : (pageName ? pageName : 'Inicial')}
                        type={pageType}
                        subtitle={isPlanosRoute ? 'Gerencie os planos e precificação de serviços' : undefined}
                        isPlanosRoute={isPlanosRoute}
                    />
                )}
                {props.children}
            </Main>

            <Toaster 
                position="top-center"
                toastOptions={{
                    duration: 3000,
                    style: {
                        background: 'var(--toast-default-bg)',
                        color: 'var(--ink-white)',
                    },
                    success: {
                        duration: 3000,
                        style: {
                            background: 'var(--cffffff)',
                            color: 'var(--c3e4b52)',
                            border: '0.5px solid #0FC758',
                            padding: '16px',
                        },
                        iconTheme: {
                            primary: 'var(--c0fc758)',
                            secondary: 'var(--cffffff)',
                        },
                    },
                    error: {
                        duration: 3000,
                        style: {
                            background: 'var(--cffffff)',
                            color: 'var(--c3e4b52)',
                            border: '0.5px solid #E52940',
                            padding: '16px',
                        },
                        iconTheme: {
                            primary: 'var(--ce52940)',
                            secondary: 'var(--cffffff)',
                        },
                    },
                }}
            />
        </Container>
    )
}
